import React, { useState } from "react"
import { withPrefix } from "gatsby"
import { useLocation } from "@reach/router"
import classNames from 'classnames';

import "./main-menu.css"
import "./submenu.css"

const MenuItem = ({ menuItems, data, currentPath, handleHover, hasSubmenu, translationSelection }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 991;

  const subMenuItems = menuItems
    .filter(item => item.parentMenuOption && item.parentMenuOption.includes(data.pageTitle))
    .sort((a, b) => a.submenuSequence - b.submenuSequence);

  const [toggleSubMenu, setToggleSubMenu] = useState(false);

  const handleToggleSubMenu = () => {
    if (isMobile) {
      setToggleSubMenu(!toggleSubMenu);
    }
  };

  let parentLinkUrl = withPrefix(data.slug);
  
  if (subMenuItems.length > 0 && data.useFirstChildLink) {
    parentLinkUrl = withPrefix(subMenuItems[0].slug);
  }

  const translatedData = data.menuNameTranslation?.filter((item) => {
    return item.title.toLowerCase() === translationSelection.toLowerCase();
  });

  const title = translatedData?.[0]?.description.description || data.pageTitle;

  return (
    <li 
      className={`relative menu-item ${subMenuItems.length > 0 && 'menu-item__submenu'} ${hasSubmenu}`}
      onClick={handleToggleSubMenu}
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}
    >
      <a
        href={parentLinkUrl}
        className={classNames({
          active: currentPath === parentLinkUrl
        })}
      >
        {title}
      </a>
      {subMenuItems.length > 0 && (
        <>
          <div
            className={`hide-min-lg submenu-icon ${isMobile ? 'mobile-click' : ''}`}
            onClick={handleToggleSubMenu}
          >
            <span className={`submenu-icon-plus ${toggleSubMenu && 'submenu-icon-plus--open'}`}></span>
          </div>
          <ul className={`submenu-pages ${toggleSubMenu && 'submenu-item--open'}`}>
            {subMenuItems.map(submenuItem => {
              let linkVal = withPrefix(submenuItem.slug);
              const translatedSubData = submenuItem.menuNameTranslation?.filter((item) => {
                return item.title.toLowerCase() === translationSelection.toLowerCase();
              });

              const subDataTitle = translatedSubData?.[0]?.description.description || submenuItem.pageTitle;
              return (
                <li key={submenuItem.id}>
                  <a
                    href={linkVal}
                    className={currentPath === withPrefix(submenuItem.slug) ? 'active' : ''}
                  >
                    {subDataTitle}
                    {/* {submenuItem.pageSubTitle && (<span className="main-submenu-title">{submenuItem.pageSubTitle}</span>)} */}
                  </a>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </li>
  );
};

const MenuButton = ({ className = "", toggleAction, isToggleMenu }) => (
  <button
    id="mobile-menu-button"
    className={`cursor-pointer mobile-menu-btn ${className}`}
    onClick={toggleAction}
  >
    <div className={`toggle ${isToggleMenu && 'active'}`}>
        <span></span>
        <span></span>
        <span></span>
    </div>
  </button>
)

const MainMenu = ({
  menuItems = [],
  hideDesktopMenuClass = "",
  showMobileMenuClass = "",
  className = "",
  isToggleMenu,
  toggleAction,
  isHeaderDark,
  languagePreference
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [hoveredMenuItem, setHoveredMenuItem] = useState(null);

  const handleHover = (menuItem) => {
    setHoveredMenuItem(menuItem);
  };

  const handleMouseLeave = () => {
    setHoveredMenuItem(null);
  };

  const hasSubmenu = hoveredMenuItem && menuItems.some(item => item.parentMenuName === hoveredMenuItem.pageTitle);
  
  const hasSubmenu1 = hoveredMenuItem && hoveredMenuItem.id === 'fbaff6ff-ec2c-5840-bd79-24f020e7efa8';

  const menuClassName = `main-menu ${hideDesktopMenuClass} ${className} ${isToggleMenu ? 'clicked' : ''} ${hoveredMenuItem ? 'parent-hovered' : ''} ${hasSubmenu ? 'has-submenu' : ''} ${hasSubmenu1 ? 'has-submenu' : ''} ${isHeaderDark ? 'menu--dark' : ''}`;

  const translationSelection = languagePreference ? languagePreference.toLowerCase() : null;

  return (
    <div className="main-menu-wrap">
      <menu id="main-menu" className={menuClassName} onMouseLeave={handleMouseLeave}>
        {menuItems.length
          ? menuItems.map((item, index) => {
              if (!item.submenuPage) {
                return (
                  <MenuItem
                    menuItems={menuItems}
                    data={item}
                    key={index}
                    currentPath={currentPath}
                    handleHover={() => handleHover(item)}
                    hasSubmenu={hasSubmenu}
                    translationSelection={translationSelection || 'English'}
                  />
                );
              }
              return null;
            })
          : null}
      </menu>
      <MenuButton className={`${showMobileMenuClass} ${isHeaderDark ? 'menu--dark' : ''}`} isToggleMenu={isToggleMenu} toggleAction={toggleAction} />
    </div>
  );
};

export default MainMenu